<template>
  <div class="dashboard d-flex justify-content-center align-items-center p-2" style="min-height: 90vh;">

    <div class="welcome-card w-100 shadow-sm p-2 p-md-3" style="border-radius: 1.5rem; max-width: 650px;">
      <div class="d-flex align-items-center flex-column flex-sm-row text-center text-sm-left">

        <div
          class="welcome-logo-container rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mb-1 mb-sm-0 mr-sm-2"
          style="width: 85px; height: 85px;"
        >
          <b-img :src="appLogoImage" :alt="$t('dashboard.logoAlt')" style="width: 45px; height: 45px; object-fit: contain;" />
        </div>

        <div>
          <h2 class="welcome-title font-weight-bolder mb-50" style="font-size: 1.6rem;">{{ $t('dashboard.welcome') }}</h2>
          <p class="welcome-text mb-0" style="font-size: 1rem; line-height: 1.5;">
            {{ $t('dashboard.description') }}
          </p>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3 d-xl-none">
        <b-button
          class="btn-inbox rounded-pill border-0 font-weight-bold d-flex align-items-center text-decoration-none"
          style="font-size: 1.2rem; padding: 0.6rem 2.5rem;"
          @click="goBackToMenu"
        >
          <span>{{ $t('dashboard.viewInbox') }}</span>
        </b-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { BImg, BButton } from 'bootstrap-vue';
import { $themeConfig } from '@themeConfig';
import * as AuthService from '@/services/AuthService';

export default {
  components: {
    BImg,
    BButton,
  },
  data() {
    return {
      resizeTimer: null,
      appLogoImage: $themeConfig.app.appLogoImage,
    };
  },
  computed: {
    ...mapState({}),
  },
  mounted() {
    this.$store.commit('replies/SET_FILTER_ITEM', { name: 'sort', value: '-updated_at' });
    this.loadUserLanguage();
    this.checkTermsAndConditions(); // Checking if T&C have been accepted
  },
  methods: {
    goBackToMenu() {
      this.$root.$emit('toggle-mobile-menu', true);
    },
    loadUserLanguage() {
      const userId = AuthService.getUserId();

      if (userId) {
        const savedLang = localStorage.getItem(`${userId}-language`);
        if (savedLang) {
          this.$i18n.locale = savedLang;
        }
      }
    },
    checkTermsAndConditions() {
      const userId = AuthService.getUserId();

      if (userId) {
        const termsRead = localStorage.getItem(`${userId}-terms-read`);
        if (termsRead !== 'true') {
          this.$root.$emit('show-terms-modal');
        }
      }
    },
  },
}
</script>

<style lang="scss">
.dashboard {
  /* --- LIGHT MODE VARIABLES --- */
  --welcome-bg: #6e4f91;
  --welcome-title-color: #ffffff;
  --welcome-text-color: #ffffff;
  --welcome-logo-grad-start: #c783e8;
  --welcome-logo-grad-end: #9b51e0;

  --inbox-btn-bg: rgba(255, 255, 255, 0.2);
  --inbox-btn-hover: rgba(255, 255, 255, 0.3);

  .welcome-card {
    background-color: var(--welcome-bg);
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .welcome-logo-container {
    background: linear-gradient(135deg, var(--welcome-logo-grad-start), var(--welcome-logo-grad-end));
  }

  .welcome-title {
    color: var(--welcome-title-color);
    transition: color 0.3s ease;
  }

  .welcome-text {
    color: var(--welcome-text-color);
    transition: color 0.3s ease;
  }

  .btn-inbox {
    color: var(--welcome-title-color) !important;
    background-color: var(--inbox-btn-bg) !important;
    transition: all 0.2s ease;

    &:hover, &:focus {
      background-color: var(--inbox-btn-hover) !important;
      color: var(--welcome-title-color) !important;
      transform: translateY(-1px);
    }
  }
}

/* --- DARK MODE OVERRIDES --- */
.dark-layout .dashboard {
  --welcome-bg: #bbafef;
  --welcome-title-color: #000000;
  --welcome-text-color: #302f2f;

  --inbox-btn-bg: rgba(0, 0, 0, 0.1);
  --inbox-btn-hover: rgba(0, 0, 0, 0.2);
}
</style>
